export const MEMBER_SLUG_PARAM = '{memberSlug}';
//# sourceMappingURL=constants.js.map